"use client";

import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { Input, Flex, Icon, utils } from "@thenounproject/lingo-core";

const { getColor } = utils;

type Props = {
  placeholder?: string;
  iconId?: string;
  defaultText?: string;

  onSubmit?: (text: string) => void;
  submitOnBlur?: boolean;
  autoFocus?: boolean;
};

const NavInputField = styled(Input).attrs({
  styleOverrides: {
    mb: "none",
    mt: "none",
  },
  type: "text",
})`
  padding: 4px;
  border: none;
  border-radius: none;
  box-shadow: none;
  background: transparent;
  margin-top: 0;
  margin-bottom: 0;
  height: 30px;

  &::placeholder {
    color: ${getColor("grayDarkest")};
  }
  &::-webkit-input-placeholder {
    color: ${getColor("grayDarkest")};
  }
  &:focus {
    outline: 0;
    border: none;
    background: ${getColor("grayLighter")};
  }
`;

const AddSectionInput: React.FC<Props> = ({
  placeholder,
  defaultText,
  onSubmit,
  iconId = "plus",
  submitOnBlur,
  autoFocus,
  ...rest
}) => {
  const [inputText, setInputText] = useState(""),
    [focused, setFocused] = useState(false);

  useEffect(() => {
    if (focused) {
      document.querySelector<HTMLInputElement>("#input-nav-pill").select();
    }
  }, [focused]);
  return (
    <Flex
      pl="xs"
      alignItems="center"
      borderRadius="default"
      background={focused ? "grayLighter" : "none"}
      {...rest}>
      {iconId && <Icon iconId={iconId} size="16" fill="grayDarkest" />}
      <NavInputField
        data-testid="navpill-input"
        id="input-nav-pill"
        placeholder={placeholder}
        autoFocus={autoFocus}
        value={inputText}
        onSubmit={() => {
          if (inputText && inputText.length > 0) {
            onSubmit(inputText);
            setInputText("");
          }
        }}
        onChange={e => setInputText(e.target.value)}
        onFocus={() => {
          setInputText(defaultText || "");
          setFocused(true);
        }}
        onBlur={() => {
          if (submitOnBlur) {
            onSubmit(inputText);
          } else {
            setInputText("");
            setFocused(false);
          }
        }}
      />
    </Flex>
  );
};

export default AddSectionInput;
